module.exports = __webpack_public_path__ + "static/media/daosquare__bg.56dc2d9b.jpg";